import { Dispatch, SetStateAction, useState } from 'react';
import { ZoomLevel } from './zoom';

export type ExperienceTimelineViewState = {
  zoom: ZoomLevel;
  hideLabels: boolean;
  collapsedLanes: Record<string, boolean>;
  expandedClusters: Record<string, boolean>;
  hoveredId: string | null;
};

export const DEFAULT_TIMELINE_VIEW_STATE: ExperienceTimelineViewState = {
  zoom: 1,
  hideLabels: false,
  collapsedLanes: {},
  expandedClusters: {},
  hoveredId: null
};

// Convenience hook bundling zoom/hideLabels/collapsedLanes/expandedClusters/
// hover into one state object, so call sites don't have to declare five
// separate useStates. Returns a plain `[state, setState]` pair — the same
// shape `ExperienceTimeline`'s `view`/`onViewChange` controlled-component
// contract expects, so `onViewChange={setState}` just works. Drive the
// transitions with the pure functions in viewReducers.ts, e.g.
// `setState(zoomInView)` or `setState(s => toggleLaneView(s, laneId))` —
// this hook is one way to hold that state, not the only way (a caller
// syncing zoom to a query param wouldn't use this hook at all).
export const useExperienceTimelineViewState = (
  initial?: Partial<ExperienceTimelineViewState>
): [ExperienceTimelineViewState, Dispatch<SetStateAction<ExperienceTimelineViewState>>] =>
  useState<ExperienceTimelineViewState>({ ...DEFAULT_TIMELINE_VIEW_STATE, ...initial });
